import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import ContributorsDetails from "modules/analyze-composite-concentration-contributors"
import "./style.scss"

export default function AnalyzeConcentrationDetails({
  account,
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  segment,
  classifications,
  selectedDate,
  selectedContributorValue,
  showContributorCategory,
  hideContributorCategory,
  viewType,
  sortOrder,
  setSortOrder,
  openFactorProfile,
  openSecurityProfile,
  currentGrouping,
  setGrouping,
  selectedGroup,
  showGroup,
  hideGroup,
  selectedOption,
  enableBasketDrillDown,
  currency,
  expand,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return (
    <div className={classnames("modules_analyze-composite-concentration-details")}>
      <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
      <ContributorsDetails {...{
        account,
        modelId,
        positionSetId,
        positionSetType,
        positionSetName,
        classifications,
        viewType,
        openSecurityProfile,
        openFactorProfile,
        segment,
        selectedGroup,
        showGroup,
        hideGroup,
        showContributorCategory,
        hideContributorCategory,
        sort: handleSort,
        sortOrder,
        selectedContributorCategory: { field: "economicExposure" },
        selectedContributorValue,
        selectedDate,
        setGrouping,
        currentGrouping,
        selectedOption,
        enableBasketDrillDown,
        currency,
        expand,
      }}
      />
    </div>
  )
}

AnalyzeConcentrationDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  segment: PropTypes.object,
  classifications: PropTypes.array,
  selectedDate: PropTypes.string,
  details: PropTypes.array,
  viewType: PropTypes.string,
  factorCategoryId: PropTypes.string,
  factorCategoryName: PropTypes.string.isRequired,
  sortOrder: PropTypes.object,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number,
  setSortOrder: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  currentGrouping: PropTypes.object,
  setGrouping: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  selectedOption: PropTypes.object.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  enableBasketDrillDown: PropTypes.bool,
  currency: PropTypes.string,
  expand: PropTypes.bool,
}
